// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/sample_metadata.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import { file_quanterix_common_extensions_v1_message_options } from "../../../common/extensions/v1/message_options_pb";
import type { SampleType } from "../../../common/types/v1/sample_type_pb";
import { file_quanterix_common_types_v1_sample_type } from "../../../common/types/v1/sample_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/sample_metadata.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_sample_metadata: GenFile = /*@__PURE__*/
  fileDesc("Cj1xdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvc2FtcGxlX21ldGFkYXRhLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEiwwMKDlNhbXBsZU1ldGFkYXRhEhYKCXNhbXBsZV9pZBgBIAEoCUgAiAEBEhgKC3NhbXBsZV9uYW1lGAIgASgJSAGIAQESPwoLc2FtcGxlX3R5cGUYAyABKA4yJS5xdWFudGVyaXguY29tbW9uLnR5cGVzLnYxLlNhbXBsZVR5cGVIAogBARIVCghkaWx1dGlvbhgEIAEoAUgDiAEBEiMKFmV4cGVjdGVkX2NvbmNlbnRyYXRpb24YBSABKAFIBIgBARIeChFtaW5fY29uY2VudHJhdGlvbhgGIAEoAUgFiAEBEh4KEW1heF9jb25jZW50cmF0aW9uGAcgASgBSAaIAQE6QIK1GDwKOgoncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxEg9QbGF0ZVdlbGxDb25maWdCDAoKX3NhbXBsZV9pZEIOCgxfc2FtcGxlX25hbWVCDgoMX3NhbXBsZV90eXBlQgsKCV9kaWx1dGlvbkIZChdfZXhwZWN0ZWRfY29uY2VudHJhdGlvbkIUChJfbWluX2NvbmNlbnRyYXRpb25CFAoSX21heF9jb25jZW50cmF0aW9uYgZwcm90bzM", [file_quanterix_common_extensions_v1_field_options, file_quanterix_common_extensions_v1_message_options, file_quanterix_common_types_v1_sample_type]);

/**
 * Contains information describing a "sample" (e.g. a blood plasma sample,
 * a commercial kit assay calibrator, or a predefined control)
 *
 * Samples are often divided into separately analyzed "replicates" during
 * the experiment preparation to improve analysis data quality and mitigate
 * the risk of loss of data, particularly in scenarios where the method of
 * obtaining the sample is costly, invasive, or otherwise difficult.
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.SampleMetadata
 */
export type SampleMetadata = Message<"quanterix.simoa_one.analysis_app_api.v1.SampleMetadata"> & {
  /**
   * Unique identifier (UUID) for the sample
   *
   * @generated from field: optional string sample_id = 1;
   */
  sampleId?: string;

  /**
   * User-friendly / human-readable name of the sample
   *
   * @generated from field: optional string sample_name = 2;
   */
  sampleName?: string;

  /**
   * Specifies the sample type (e.g. Calibrator, Control, Unknown)
   *
   * @generated from field: optional quanterix.common.types.v1.SampleType sample_type = 3;
   */
  sampleType?: SampleType;

  /**
   * Dilution of the sample as prepared for the experiment
   *
   * @generated from field: optional double dilution = 4;
   */
  dilution?: number;

  /**
   * Expected concentration value of the sample (output from analysis)
   *
   * @generated from field: optional double expected_concentration = 5;
   */
  expectedConcentration?: number;

  /**
   * Expected minimum concentration value for a range definition
   *
   * @generated from field: optional double min_concentration = 6;
   */
  minConcentration?: number;

  /**
   * Expected maximum concentration value for a range definition
   *
   * @generated from field: optional double max_concentration = 7;
   */
  maxConcentration?: number;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.SampleMetadata.
 * Use `create(SampleMetadataSchema)` to create a new message.
 */
export const SampleMetadataSchema: GenMessage<SampleMetadata> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_sample_metadata, 0);

